import { defineMessages } from 'react-intl';

type MessageKeys = 'starred' | 'all' | 'pickerLabel' | 'pickerLabelGalaxia';

const messages: Record<MessageKeys, { defaultMessage: string; description: string; id: string }> =
	defineMessages({
		starred: {
			id: 'atlassian-studio-common.picker.starred',
			defaultMessage: 'Starred',
			description: 'Label for starred project/spaces in picker',
		},
		all: {
			id: 'atlassian-studio-common.picker.all',
			defaultMessage: 'All',
			description: 'Label for remaining project/spaces in picker',
		},
		pickerLabel: {
			id: 'atlassian-studio-common.picker.pickerLabel',
			defaultMessage: 'Jira projects and Confluence spaces search picker',
			description: 'Accessibility label for the picker search input',
		},
		pickerLabelGalaxia: {
			id: 'atlassian-studio-common.picker.pickerLabelGalaxia',
			defaultMessage: 'Jira and Confluence spaces search picker',
			description: 'Accessibility label for the picker search input',
		},
	});
export default messages;
